const img = require('./walletconnect.png'); export default img;